<script lang="ts" setup>
	defineProps<{
		loading?: boolean
	}>()
</script>

<template>
	<div>
		<a-button class="export-btn custom-transition-2 group">
			<lazy-tools-icon
				v-show="!loading"
				dir="system"
				icon="export"
				path-class="group-hover:stroke-white stroke-primary-2 "
			/>
			<lazy-tools-icon
				v-show="loading"
				dir="line"
				icon="eclipse"
				circle-class="group-hover:stroke-white stroke-primary-2 "
			/>
			<span class="font-medium group-hover:text-white"> Export Data </span>
		</a-button>
	</div>
</template>

<style scoped>
	.export-btn {
		@apply flex h-[45px] items-center gap-x-2 rounded border border-primary-2 px-2 py-1.5 text-primary-2 hover:bg-primary-2 hover:text-white;
	}
</style>
